<!-- src/components/dashboard/rent_to_own/RentToOwnTip.vue -->
<!-- FT-173 (замечание USER 2026-09-25: «нет пояснений, нет tooltips»): пояснение
     к показателю, чипу, кнопке действия или колонке — штатный v-tooltip.
     Активатор — обёртка-span вокруг слота: так подсказка работает и у
     неактивной кнопки («Завершить» без оплаченного графика — disabled-кнопка
     сама событий мыши не получает, обёртка получает). icon — значок
     mdi-information-outline рядом со слотом (подпись показателя, заголовок
     колонки): он и сообщает, что здесь есть пояснение, и открывает его по
     касанию на телефоне (open-on-click, образец CompanyProfile.vue).

     С клавиатуры (часть H, Codex rev4) подсказка открывается по фокусу:
     - icon — значок это кнопка-иконка с aria-label = текст пояснения;
     - без icon — обёртка сама фокусируется (tabindex="0") и описана скрытым
       текстом пояснения (aria-describedby, d-sr-only);
     - focusable=false — обёртка вокруг своей кнопки: второй остановки Tab не
       нужно, подсказку открывает фокус этой кнопки (focusin всплывает).

     Касание и клик по значку «i» (часть I, контроль rev5): подсказка
     открывается и закрепляется (pinned) — уход указателя её не закрывает;
     повторное касание или клик закрывает, касание вне — тоже (фокус уходит
     с кнопки → focusout). retain-focus-on-click: иначе VBtn.click() снимал
     фокус (e.detail ≠ 0), focusout гасил таймер открытия, и на Android
     подсказка не открывалась вовсе. -->
<template>
  <!-- Корень — обычный span: классы отступов родителя (mr-2 и т.п.) ложатся
       на него; у корня v-tooltip Vuetify display: none, отступы там не
       действуют. -->
  <span class="d-inline-flex">
    <v-tooltip v-model="active" :top="top" :bottom="!top" max-width="320">
      <template #activator="{ on, attrs }">
        <span
          class="rent-to-own-tip d-inline-flex align-center"
          v-bind="attrs"
          :tabindex="ownFocus ? 0 : undefined"
          :aria-describedby="ownFocus ? descriptionId : undefined"
          v-on="keyboardListeners(on)"
        >
          <slot></slot>
          <v-btn v-if="icon" icon x-small retain-focus-on-click class="ml-1" :aria-label="text" @click="togglePinned">
            <v-icon x-small>mdi-information-outline</v-icon>
          </v-btn>
        </span>
      </template>
      <span class="rent-to-own-tip__text">{{ text }}</span>
    </v-tooltip>
    <span v-if="ownFocus" :id="descriptionId" class="d-sr-only">{{ text }}</span>
  </span>
</template>

<script>
export default {
  name: "RentToOwnTip",
  props: {
    text: { type: String, required: true },
    icon: { type: Boolean, default: false },
    top: { type: Boolean, default: false },
    // false — в слоте своя фокусируемая кнопка (действие, «Принять платёж»).
    focusable: { type: Boolean, default: true },
  },
  data() {
    return { active: false, pinned: false };
  },
  computed: {
    ownFocus() {
      return !this.icon && this.focusable;
    },
    descriptionId() {
      return `rent-to-own-tip-${this._uid}`;
    },
  },
  methods: {
    // focus/blur у v-tooltip не всплывают — фокус вложенной кнопки (значок
    // «i», кнопка действия) до обёртки не доходил. focusin/focusout всплывают.
    keyboardListeners(on) {
      const listeners = Object.assign({}, on);
      if (on.focus) listeners.focusin = on.focus;
      if (on.blur) {
        listeners.focusout = (e) => {
          this.pinned = false;
          on.blur(e);
        };
      }
      if (on.mouseleave) {
        // Закреплённая касанием или кликом подсказка уходом указателя не закрывается.
        listeners.mouseleave = (e) => {
          if (!this.pinned) on.mouseleave(e);
        };
      }
      if (on.keydown) {
        listeners.keydown = (e) => {
          if (e.keyCode === 27) this.pinned = false;
          on.keydown(e);
        };
      }
      delete listeners.focus;
      delete listeners.blur;
      return listeners;
    },
    togglePinned() {
      this.pinned = !this.pinned;
      this.active = this.pinned;
    },
  },
};
</script>
